import {SIGNUP_SELECT_IDENTITY, SIGNUP_QUALIFICATION, SIGNIN_INCOMPLETE_QUALIFICATION} from '../../../signin-signup-steps';

Hop.defineModule('signup-confirm', (root, opts = {}) => {
    const modal = root.querySelector('.modal');
    const closeButtons = root.querySelectorAll('.modal__close');
    const $modal = $(modal);
    const open = opts.open || false;

    let clientActive = false;
    let freelancerActive = false;

    const $selectClient = root.querySelector('[data-select-client]');
    const $selectFreelancer = root.querySelector('[data-select-freelancer]');
    const $confirmIdentity = root.querySelector('[data-confirm-identity]');
    const $identitySelection = root.querySelector('[data-identity-selection]');
    const $modalConfirmClient = root.querySelector('[data-modal-confirm-client]');

    function populateClientForm(client, redirect, $form) {
        const $redirect = $form.querySelector('[name="redirect"]');
        if ($redirect) {
            $redirect.value = redirect;
        }

        Object.keys(client).forEach((name) => {
            const value = client[name];
            if (value) {
                const $field = $form.querySelector(`[name=${name}]`);
                if ($field) {
                    if ($field.tagName === 'JOY-SELECT') {
                        const $options = $field.querySelectorAll('option');
                        $options.forEach((option) => (option.value === value ? (option.selected = true) : (option.selected = false)));
                    } else {
                        $field.value = `${value}`;
                    }
                    $field.parentNode.classList.add('active');
                }
            }
        });
    }

    function initializeClientForm() {
        const client = parseClientData();
        if (client) {
            showClientCompletionStep();
            const $formClient = root.querySelector('[data-form="client"]');
            if ($formClient) {
                populateClientForm(client, parseRedirectUrl(), $formClient);
            }
        }
    }

    function initializeInvitationForm() {
        if (!window.HopConnectPopupSettings.fromInvitation) {
            return;
        }

        const $companyName = root.querySelector('[name="companyName"]');
        if ($companyName) {
            $companyName.parentElement.hidden = true;
            $companyName.required = false;
        }

        const $companySize = root.querySelector('[name="companySize"]');
        if ($companySize) {
            $companySize.parentElement.hidden = true;
            $companySize.required = false;
        }

        const $freelanceSection = root.querySelector('[data-section="freelance"]');
        if ($freelanceSection) {
            $freelanceSection.hidden = true;
        }
    }

    function parseClientData() {
        try {
            const clientDataAsJson = modal.getAttribute('data-client');
            return clientDataAsJson ? JSON.parse(clientDataAsJson) : null;
        } catch (e) {
            return null;
        }
    }

    function parseRedirectUrl() {
        try {
            return modal.getAttribute('data-redirect') || null;
        } catch (e) {
            return null;
        }
    }

    function toggleCloseabledState() {
        for (const close of closeButtons) {
            close.hidden = modal.getAttribute('data-closeable') === 'false';
        }
    }

    function onShow() {
        toggleCloseabledState();
        initializeClientForm();
        initializeInvitationForm();
    }

    function onClosed() {
        Hop.events.trigger('signup-confirm:closed');
    }

    function bindModalEvents() {
        $modal.on('show.bs.modal', onShow);
        $modal.on('hidden.bs.modal', onClosed);
    }

    function unbindModalEvents() {
        $modal.off('show.bs.modal', onShow);
        $modal.off('hidden.bs.modal', onClosed);
    }

    function autoOpenIfNeeded() {
        if (open) {
            $modal.modal('show');
        }
    }

    function clientQualificationNextStep() {
        const step = modal.getAttribute('data-qualification');

        if (step === SIGNUP_SELECT_IDENTITY) {
            $modal.attr('data-qualification', SIGNUP_QUALIFICATION);
        } else {
            $modal.attr('data-qualification', SIGNIN_INCOMPLETE_QUALIFICATION);
        }
    }

    function showClientCompletionStep() {
        $identitySelection.hidden = true;
        $modalConfirmClient.hidden = false;

        clientQualificationNextStep();
    }

    function toggleClient() {
        clientActive = !clientActive;
        freelancerActive = false;
        $selectFreelancer.classList.remove('active');
        if (clientActive) {
            $selectClient.classList.add('active');
        } else {
            $selectClient.classList.remove('active');
        }
        refreshConfirmStyle();
    }

    function toggleFreelancer() {
        freelancerActive = !freelancerActive;
        clientActive = false;
        $selectClient.classList.remove('active');
        if (freelancerActive) {
            $selectFreelancer.classList.add('active');
        } else {
            $selectFreelancer.classList.remove('active');
        }
        refreshConfirmStyle();
    }

    function refreshConfirmStyle() {
        $confirmIdentity.disabled = !(freelancerActive || clientActive);
    }

    function confirmIdentity() {
        if (clientActive) {
            showClientCompletionStep();
        }
        if (freelancerActive) {
            const redirectUrl = parseRedirectUrl();
            if (redirectUrl !== null) {
                const groupInvitationUrl = '/group/signin/';
                const groupInvitationIndex = redirectUrl.indexOf(groupInvitationUrl);
                if (groupInvitationIndex === 0) {
                    const groupInvitationId = redirectUrl.substring(groupInvitationUrl.length, redirectUrl.lastIndexOf('/'));
                    window.location.href = `/profile/creation?fromInvit=${groupInvitationId}`;
                    return;
                }
            }

            window.location.href = '/profile/creation';
        }
    }

    function bindIdentitySelection() {
        if ($selectClient) {
            $selectClient.addEventListener('click', toggleClient);
        }
        if ($selectFreelancer) {
            $selectFreelancer.addEventListener('click', toggleFreelancer);
        }
        if ($confirmIdentity) {
            $confirmIdentity.addEventListener('click', confirmIdentity);
        }
    }

    function unbindIdentitySelection() {
        if ($selectClient) {
            $selectClient.removeEventListener('click', toggleClient);
        }
        if ($selectFreelancer) {
            $selectFreelancer.removeEventListener('click', toggleFreelancer);
        }
        if ($confirmIdentity) {
            $confirmIdentity.removeEventListener('click', confirmIdentity);
        }
    }

    function init() {
        bindModalEvents();
        autoOpenIfNeeded();
        bindIdentitySelection();
    }

    init();

    return function destroy() {
        unbindModalEvents();
        unbindIdentitySelection();
    };
});
